<div class="row" *ngIf="!sessionService.isAuthenticated()">
  <div class="col-lg-1"></div>
  <div class="col-md-12 col-lg-5">
      <div class="row justify-content-lg-center white-panel">
          <div class="col-md-12  col-lg-11">
            <div class="hightlight-banner">
              <img src="../../assets/comply-screen-300.jpg"  title="Comply by Edulink"/>
            </div>
            <h3 class="hightlight-banner-text">New Mandated Trainings!</h3>
            <div class="hightlight-banner-list">
              <div>
                <h4>New Templates Available Now…</h4>
                <ul >
                  <li>Act 13 Educator Effectiveness</li>
                  <li>Professional Ethics</li>
                  <li>Common Ground (Culturally Relevant and Sustaining Education)</li>
                </ul>
                <h4 >Coming Soon…</h4>
                <ul >
                  <li >Developing Teacher Competency Training</li>
                  <li >Increase Student Learning Training</li>
                </ul>
                <h4 >New Features Coming in 2025!</h4>
                <ul >
                  <li >Volunteer Tracking Module</li>
                  <li >Variety of Enhancements</li>
                </ul>
              </div>

              <p class="text-center"><a class="btn btn-primary hightlight-button" href="https://edulink.freshdesk.com/support/home" target="_blank"role="button">Questions/Contact Support</a></p>

            </div>
          </div>
      </div>
  </div>

  <div class="col-md-12 col-lg-5">
      <div class="row justify-content-lg-center white-panel">
          <div class="col-md-12 col-lg-10">
              <ui-view name="login-content"></ui-view>
          </div>
      </div>
  </div>
  <div class="col-lg-1"></div>
</div>
